module.exports = __webpack_public_path__ + "static/media/negative_notification.6c83da86.wav";